const CACHE_TTL = 60 * 1000; // 60 segundos

const centerCache = new Map();

function normalizeIdentityPart(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function getCenterIdentity(center) {
  if (!center || typeof center !== "object") {
    return normalizeIdentityPart(center);
  }

  const region = normalizeIdentityPart(center.region);
  const area = normalizeIdentityPart(center.area);
  const centro = normalizeIdentityPart(center.centro || center.centerName);

  return [region, area, centro].filter(Boolean).join("|");
}

export function getFromCenterCache(center) {
  const entry = centerCache.get(getCenterIdentity(center));
  if (!entry) return null;

  const isExpired = Date.now() - entry.timestamp > CACHE_TTL;
  if (isExpired) {
    centerCache.delete(getCenterIdentity(center));
    return null;
  }

  return entry.data;
}

export function saveToCenterCache(center, data) {
  centerCache.set(getCenterIdentity(center), {
    data,
    timestamp: Date.now(),
  });
}

export function clearCenterCache() {
  centerCache.clear();
}
